<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters align="center">
      <v-col cols="auto">
        <MachineModelImage :key="imagekey" :relativePath="item.ModelImage" :size="290" editable @File="setImage">
        </MachineModelImage>
      </v-col>
      <v-divider vertical style="z-index: 1;"></v-divider>
      <v-col cols="0" class="pa-3">
        <v-row no-gutters>
          <v-col cols="0" class="pr-3">
            <template v-if="editMode">
              <QTextField v-model="item.ProductNumber" :label="$t('servicesystem.common_objects.model.product_number')"
                externaledit @FocusState="handleFocus">
              </QTextField>
              <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.model.name')" externaledit
                class="mt-3" @FocusState="handleFocus">
              </QTextField>
              <QTextField v-if="item.AlternativeName" v-model="item.AlternativeName"
                :label="$t('servicesystem.common_objects.model.alternative_name')" externaledit class="mt-3"
                @FocusState="handleFocus">
              </QTextField>
            </template>
            <template v-else>
              <h4 v-text="item.ProductNumber || 'N/A'" style="opacity: 0.75;">
              </h4>
              <h1 v-text="item.Name || 'Unnamed model'" class="my-1">
              </h1>
              <h5 v-if="item.AlternativeName && item.AlternativeName != item.Name" v-text="item.AlternativeName"
                style="opacity: 0.60;">
              </h5>
            </template>
          </v-col>
          <v-col cols="auto">
            <template v-if="editMode">
              <MachineTypeSelect v-model="item.MachineTypeId" :externaledit="editMode" allowCreate
                @FocusState="handleFocus">
              </MachineTypeSelect>
              <SupplierSelect v-model="item.SupplierId" :externaledit="editMode" allowCreate class="mt-3"
                @FocusState="handleFocus">
              </SupplierSelect>
            </template>
            <template v-else>
              <table>
                <tr>
                  <td style="text-align: end;" class="pr-2">
                    {{ $t('servicesystem.common_objects.machine_type.machine_type') }}
                  </td>
                  <td>
                    <v-card color="primary" dark style="padding: 3px 6px; width: fit-content;"
                      :to="{ name: 'ViewMachineType', params: { typeId: item.MachineTypeId } }">
                      {{ item.MachineType.Name }}
                    </v-card>
                  </td>
                </tr>
                <tr>
                  <td style="text-align: end;" class="pr-2 pt-2">
                    {{ $t('servicesystem.common_objects.machine.supplier') }}
                  </td>
                  <td class="primary--text pt-2">
                    <router-link :to="{ name: 'ViewSupplier', params: { supplierId: item.SupplierId } }"
                      class="primary--text minimalLink" style="font-size: 13px;">
                      {{ item.Supplier.Name }}
                    </router-link>
                  </td>
                </tr>
              </table>
            </template>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-3">
          <v-col cols="12">
            <QTextArea v-model="item.ModelDescription" :label="$t('servicesystem.common_objects.model.description')"
              :externaledit="editMode" placeholder="No description set" @FocusState="handleFocus">
            </QTextArea>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <template v-if="editMode">
              <MachineModelSelect v-model="item.ParentId" :label="$t('servicesystem.common_objects.model.parent')"
                :externaledit="editMode" allowCreate clearable class="mt-3" @FocusState="handleFocus">
              </MachineModelSelect>
            </template>
            <template v-else>
              <v-card v-if="item.Parent" outlined class="px-2 my-2"
                :to="{ name: 'ViewMachineModel', params: { modelId: item.Parent.Id } }"
                style="background-color: #427aaf17; border-color: var(--v-primary-base);">
                <v-row no-gutters align="center">
                  <v-col cols="auto">
                    This model is a variation of
                  </v-col>
                  <v-col cols="0">
                    <v-list-item dense class="pr-0">
                      <v-list-item-icon class="my-0 mr-2">
                        <MachineModelImage :relativePath="item.Parent.ModelImage" :size="40">
                        </MachineModelImage>
                      </v-list-item-icon>
                      <v-list-item-content class="py-1">
                        <v-list-item-subtitle>
                          {{ item.Parent.ProductNumber }}
                        </v-list-item-subtitle>
                        <v-list-item-title>
                          {{ item.Parent.Name }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="my-auto ml-2">
                        <v-icon size="20">mdi-arrow-right</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </v-col>
        </v-row>
        <v-row v-if="!editMode" no-gutters>
          <v-col cols="12">
            <p class="mb-1">
              There are <b>{{ item.MachineCount }}</b> active machines of this model.
              <router-link :to="routeToMachineList" class="primary--text minimalLink">
                View list
              </router-link>
            </p>
            <!-- 
            <p class="mb-1">
              There are <b>15</b> jobs with machines of this model.
              <router-link :to="routeToMachineList" class="primary--text minimalLink">
                View list
              </router-link>
            </p>
          
            <p class="mb-1">
              The following resourcves are available for this model;
            <ul>
              <li><b>12</b> Manuals</li>
              <li><b>5</b> Forms</li>
              <li><b>1</b> Part drawings</li>
            </ul>
            <router-link :to="{ name: 'ViewMachineModelResources' }" class="primary--text minimalLink">
              View resources
            </router-link>
            </p>
            -->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import MachineModelSelect from '@/components/Inputs/EntityDropdowns/MachineModelSelect2.vue';
import MachineTypeSelect from '@/components/Inputs/EntityDropdowns/MachineTypeSelect2.vue';
import SupplierSelect from '@/components/Inputs/EntityDropdowns/SupplierSelect2.vue';
import MachineModelImage from "@/views/job/newjob/cards/machines/MachineModelImage.vue";
import Vue from "vue";

export default {
  name: "MachineModelEditContent",
  props: {
    item: Object,
    editMode: Boolean,
    edittrigger: Number,
    handleFocus: {
      type: Function,
      default: () => { },
    }
  },
  components: {
    MachineModelImage,
    MachineTypeSelect,
    SupplierSelect,
    MachineModelSelect,
  },
  mixins: [],

  data() {
    return {
      imagekey: 1,
    };
  },

  mounted() { },

  methods: {
    setImage(file) {
      //console.log("setImage", file);
      this.handleFocus(true);
      //this.item.ModelImage = Math.random().toString(36).substring(2, 15);
      Vue.set(this.item, "newImage", file);
    },
  },

  computed: {
    routeToMachineList() {
      return {
        name: "MachineList",
        query: { "ML-filter-models": JSON.stringify([this.item.Id]) },
      };
    },
  },

  watch: {
    editMode: function (val) {
      if (!val) {
        this.imagekey++;
      }
    },
  },
};
</script>


<style lang='scss'></style>
